export const API_BASE_URL = process.env.VUE_APP_API_BASE_URL
export const STORAGE_BASE_URL = process.env.VUE_APP_STORAGE_BASE_URL
export const NO_IMAGE_URL = process.env.VUE_APP_NO_IMAGE_URL

/**
 * Construye una URL absoluta dentro de /storage.
 * - Si path es vacío/falsy -> NO_IMAGE_URL
 * - Si path ya es absoluta (http/https) -> se respeta
 * - Si path es relativa -> se concatena con STORAGE_BASE_URL
 */
export function buildStorageUrl(path) {
  if (!path) return NO_IMAGE_URL
  if (/^https?:\/\//i.test(path)) return path
  const base = String(STORAGE_BASE_URL || '').replace(/\/+$/, '')
  const rel = String(path).replace(/^\/+/, '')
  return `${base}/${rel}`
}
